import Vue from 'vue';
import moment from 'moment';

Vue.filter('formatDateTime', (value, filterFormat) => {
  let momentObj = moment(value);

  if (value) {
    return momentObj.format(filterFormat);
  }
  return '';
});

Vue.filter('formatDate', (value, filterFormat) => {
  let momentObj = moment(value);

  if (value) {
    return momentObj.format(filterFormat);
  }
  return '';
});
